import { createFileRoute, redirect } from '@tanstack/react-router'
import { RevenuePage } from '@/pages/Revenue/RevenuePage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/revenue')({
  component: RevenuePage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/revenue')) {
      throw redirect({ to: '/' })
    }
  },
})
